<section class="c-section c-section--first c-section--last c-section--open c-section--static chatbot-introduction">
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
	<div *ngIf="!vm.loading && vm.service" class="chatbot-introduction__content">
		<div class="chatbot-introduction__hero">
			<div class="chatbot-introduction__avatar">
				<avatar size="lg" [user]="vm.service.user" [default]="'bot'" [origin]="vm.origin"></avatar>
			</div>
			<h1 class="c-section__title c-text c-text--center u-ost-md">{{ 'ChatBot_Introduction.Title' | translate }}</h1>
			<p class="chatbot-introduction__tagline">{{ 'ChatBot_Introduction.Description' | translate }}</p>
			<div class="chatbot-introduction__ai-label">
				<img class="chatbot-introduction__bot-icon"
					src="https://dqs3afosyxqoy.cloudfront.net/assets/shared/robot-icon.svg"
					alt=""
					aria-hidden="true">
				{{ 'ChatBot_Introduction.Ai_Notice' | translate }}
			</div>
		</div>

		<div class="chatbot-introduction__card chatbot-introduction__card--positive">
			<h2 class="c-text">{{ 'ChatBot_Introduction.Great_For' | translate }}</h2>
			<ul>
				<li>{{ 'ChatBot_Introduction.Great_For_Stress' | translate }}</li>
				<li>{{ 'ChatBot_Introduction.Great_For_Habits' | translate }}</li>
				<li>{{ 'ChatBot_Introduction.Great_For_Reflection' | translate }}</li>
			</ul>
		</div>

		<div class="chatbot-introduction__card chatbot-introduction__card--negative">
			<h2 class="c-text">{{ 'ChatBot_Introduction.Not_For' | translate }}</h2>
			<ul>
				<li>{{ 'ChatBot_Introduction.Not_For_Crisis' | translate }}</li>
				<li>{{ 'ChatBot_Introduction.Not_For_Medical' | translate }}</li>
			</ul>
		</div>

		<div class="chatbot-introduction__crisis">
			<p class="c-text">
				{{ 'ChatBot_Introduction.Crisis' | translate }}
				<a href="https://findahelpline.com/" target="_blank" rel="noopener noreferrer">{{ 'ChatBot_Introduction.Find_Helpline' | translate }}</a>
			</p>
		</div>

		<p *ngIf="vm.startFailed" class="c-text c-text--error c-text--center u-ost-md">
			{{ 'Common.Error_Default' | translate }}
		</p>

		<div class="chatbot-introduction__actions">
			<div>
				<button id="chatBotIntroductionBackButton"
					type="button"
					class="c-button c-button--link c-button--fit"
					(click)="vm.goBack($event)">
					{{ 'Common.Back' | translate }}
				</button>
			</div>
			<div>
				<button id="chatBotConfirmStartButton"
					type="button"
					class="c-button {{ vm.buttonTheme }} c-button--fit"
					[disabled]="vm.starting"
					(click)="vm.startChat()">
					{{ 'Services.Other.Start_Chat' | translate }}
				</button>
			</div>
		</div>
	</div>

	<div *ngIf="!vm.loading && vm.loadFailed" class="c-content c-text c-text--center">
		<p>{{ 'Common.Error_Default' | translate }}</p>
	</div>
</section>
